__turbopack_context__.v({
  "snackbars-container": "TurnrSnackbarsHandler-module-scss-module__hSmY4G__snackbars-container",
});
